export default {
  siteData: state => state.siteInfo.siteData,
  visibleCalc: state => state.examination.visibleCalc,
  commonInfo: state => state.examination.commonInfo,
  quesTypeShowMap: state => state.examination.quesTypeShowMap,
  quesShowList: state => state.examination.quesShowList,
  userAnsMap: state => state.examination.userAnsMap,
  submitData: state => state.examination.submitData,
  questions: state => state.examination.questions,
  currentQuestion: state => state.examination.currentQuestion,
  currentQuestionType: state => state.examination.currentQuestionType,
  currentQuestionIndex: state => state.examination.currentQuestionIndex
}
